import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalCaveatsComponent } from './legal-caveats/legal-caveats.component';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { LegalModule, PaddingModule, GridModule } from '@frk/eds-components';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { PipesModule } from '@shared/pipes/pipes.module';

@NgModule({
  declarations: [LegalCaveatsComponent],
  // imports: [BrSdkModule, CommonModule, LegalModule, SharedModule],
  imports: [
    BrSdkModule,
    CommonModule,
    LegalModule,
    PaddingModule,
    GridModule,
    PipesModule,
  ],
  entryComponents: [LegalCaveatsComponent],
  providers: [
    // GraphQLFundDataService,
    // CaveatService,
  ],
})
export class CaveatsModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Legal/Footnote Caveats': LegalCaveatsComponent,
    };
  }
}
